const content = null;

document.body.classList.add( 'paywall-fade-hidden' );

// Kickbox response messages.
// Please check Kickbox documentation.
const errorMessages = {
	invalid_email: 'Specified email is not a valid email address syntax.',
	invalid_domain: 'Domain for email does not exist',
	rejected_email: 'Email address was rejected by the SMTP server, email address does not exist',
	no_connect: 'Could not connect to SMTP server',
	timeout: 'SMTP session timed out',
	invalid_smtp: 'SMTP server returned an unexpected/invalid response',
	unavailable_smtp: 'SMTP server was unavailable to process our request',
	unexpected_error: 'An unexpected error has occurred',
};

/**
 * escapeHTML
 *
 * This function replaces unsafe HTML characters with safe ones
 *
 * @param {string} htmlStr
 * @return {string} html safe string
 */
function escapeHTML( htmlStr ) {
	return htmlStr.replace( /&/g, '&amp;' )
		.replace( /</g, '&lt;' )
		.replace( />/g, '&gt;' )
		.replace( /"/g, '&quot;' )
		.replace( /'/g, '&#39;' );
}

/**
 * validUserHasAccess
 *
 * This function does an AJAXs call to the backend to validate a user and confirm
 * weather they have access to the article or not. It sets the global object with
 * the correct values then calls paywall logic functions to use that global object
 */
function validUserHasAccess() {
	const ajaxUrl = window.QalaPaywall.ajax_url;
	let requestData = {
		action: 'qala_pay_wall_data',
		currentPostId: window.QalaPaywall.currentPostId,
	};

	requestData = Object.assign( requestData, window.QalaPaywall.dataToMerge );

	jQuery.get( ajaxUrl, requestData, function( response ) {
		const { success } = response;
		if ( ! success ) {
			// console.error( 'User check ajax failed.' );
		} else {
			window.QalaPaywall.isGatingActive = response.isGatingActive;
			window.QalaPaywall.hasGatingAccess = response.hasGatingAccess;
			window.QalaPaywall.gatingType = response.gatingType;

      const wrapper = window.document.querySelector( '.paywall-wrapper' );

			if (wrapper && response?.gatingType !== 'free_registration') {
				wrapper.outerHTML = response.renderedGate;
			}

			if ( response.hasOwnProperty( 'downloadHTML' ) ) {
				const downloadHTML = document.createElement( 'div' );
				window.document.querySelector( 'article.post-wrap .post-content' ).append(
					downloadHTML
				);
				downloadHTML.outerHTML = response.downloadHTML;
			}
		}
		initRedirectHandler();
		initLoginForm();
		initSoftGating();
		initDownloadButtons();
		paywallLogic();
		showURLMessage();
	} );
}

/**
 * paywallLogic
 *
 * This function hides and shows the paywall based on the users access
 */
function paywallLogic() {
	if ( ! ( 'QalaPaywall' in window ) || ! window.QalaPaywall ) {
		return;
	}
	// Clean variables
	window.QalaPaywall.isGatingActive = ( window.QalaPaywall.isGatingActive === true || window.QalaPaywall.isGatingActive === '1' );
	window.QalaPaywall.hasGatingAccess = ( window.QalaPaywall.hasGatingAccess === true || window.QalaPaywall.hasGatingAccess === '1' );

	const isGatingActive = window.QalaPaywall.isGatingActive;
	const hasGatingAccess = window.QalaPaywall.hasGatingAccess;
	const gatingType = window.QalaPaywall.gatingType;
	const currentPostId = window.QalaPaywall.currentPostId;

	// If has access, show content
	if ( isGatingActive === false || hasGatingAccess === true || gatingType === 'none' ) {
		hideExcerpt();
		showContent();
	}

	if ( isGatingActive === true && hasGatingAccess === false && gatingType !== 'none' ) {
		const postContent = document.querySelector( '.post-content' );

		if ( postContent ) {
			// Add class for Google SEO schema, check PaywallGatingLogic->addGooglePaywallScript.
			postContent.classList.add( 'google-ld-json' );
		}

		if ( gatingType === 'soft_gate' ) {
			// Check soft gating cookie
			checkCookies( currentPostId );
			showExcerpt();
			hideContent();
		}

		showExcerpt();
		hideContent();
	} else {
		hideExcerpt();
		showContent();
	}
}

// Gating display logic.
jQuery( document ).ready( function() {
	// Add fade in effect on load to avoid content flickering.
	document.body.classList.add( 'paywall-fade-visible' );
	document.body.classList.remove( 'paywall-fade-hidden' );
	paywallLogic();
	initRedirectHandler();
	initLoginForm();
	initSoftGating();
	initDownloadButtons();
	validUserHasAccess();
	showURLMessage();
	moveLoginHtml();
} );

// If gating type is by number of articles read, it will check if current post
// is allready inside cookie, if not add it to the cookie.
function checkCookies( currentPostId ) {
	const cookieReads = getCookie( 'kelsey_soft_reads' );
	const paywallForm = document.querySelector( '.paywall-form' );
	const trialtype = paywallForm.getAttribute( 'data-trial-status' );

	if ( cookieReads && trialtype === 'by_articles_read' ) {
		const regex = /\d+/g;
		const postsReads = cookieReads.match( regex );

		if ( ! postsReads.includes( currentPostId ) ) {
			postsReads.push( currentPostId );
			const newPosts = postsReads.join( ',' );
			updateOakArticleRead( paywallForm, newPosts, currentPostId );
		}
	}
}

// Check if email is registered on OAK.
function updateOakArticleRead( form, newPosts, currentPostId ) {
	const cookie = getCookie( 'kelsey_soft_data' );
	const cookieData = atob( cookie );
	const email = cookieData.split( ',' )[ 0 ];

	const ajaxUrl = window.QalaPaywall.ajax_url;
	const ajaxData = {
		action: 'oak_update_article',
		email,
		currentPostId,
	};

	jQuery.post( ajaxUrl, ajaxData, function( response ) {
		const { success, data } = response;
		const responseBody = JSON.parse( data.body );

		if ( ! success ) {
			removeErrorMessage();
			form.insertAdjacentHTML( 'beforeBegin', getErrorMessage( 'Error', 'Network error, please try again later or ' + getContactLink( 'contact our support.' ), false ) );
			toggleSubmitButton( form, true );
		} else if ( responseBody.result === 'Failure' || responseBody.result === 'InvalidRequest' ) {
			removeErrorMessage();
			form.insertAdjacentHTML( 'beforeBegin', getErrorMessage( 'Error', 'Network error, please try again later or ' + getContactLink( 'contact our support.' ), false ) );
			toggleSubmitButton( form, true );
		} else {
			document.cookie = 'kelsey_soft_reads=' + newPosts + '; Path=/';
			// eslint-disable-next-line no-undef
			location.reload();
		}
	} );
}

// Function to get cookie value by cookie name.
function getCookie( name ) {
	const re = new RegExp( name + '=([^;]+)' );
	const value = re.exec( document.cookie );
	return ( value !== null ) ? unescape( value[ 1 ] ) : null;
}

// Show excerpt text with shadow.
function showExcerpt() {
	const postExcerpt = document.querySelector( '.post-excerpt-content' );

	if ( postExcerpt ) {
		postExcerpt.classList.add( 'paywall-shadow' );
	}

	jQuery( '.post-excerpt-content' ).show();
}

// Hide excerpt text.
function hideExcerpt() {
	jQuery( '.post-excerpt-content' ).hide();
}

// Hide content.
function hideContent() {
	jQuery( '.post-content' ).hide();
	showPaywall();
}

// Hide paywall
function hidePaywall() {
	jQuery( '.paywall-wrapper:not(.keep)' ).hide();
	jQuery( '.post-preview' ).hide();
}

// Show paywall
function showPaywall() {
	jQuery( '.paywall-wrapper' ).show();
	jQuery( '.post-preview' ).show();
}

// Show content.
function showContent() {
	if ( ! content ) {
		jQuery( '.editable-content' ).addClass( 'is-visible' );
		jQuery( 'body' ).addClass( 'is-paywall-visible' );
	} else {
		jQuery( '.post-content' ).append( content );
	}
	jQuery( '.post-content' ).show();
	hidePaywall();
}

// Login form setup
function initLoginForm() {
	const paywallWrapper = document.querySelector( '.paywall-wrapper' );

	if ( paywallWrapper ) {
		const loginButton = paywallWrapper.querySelector( '.paywall-notice-link' );
		const paywallLoginModal = document.querySelector( '.paywall-login' );

		if ( loginButton && paywallLoginModal ) {
			const paywallLoginClose = paywallLoginModal.querySelector( '.paywall-login-close' );
			const paywallLoginButton = paywallLoginModal.querySelector( '.paywall-login-button' );

			loginButton.addEventListener( 'click', event => {
				event.preventDefault();
				paywallLoginModal.style.display = 'flex';
			} );

			paywallLoginClose.addEventListener( 'click', event => {
				event.preventDefault();
				paywallLoginModal.style.display = 'none';
			} );

			window.onclick = function( event ) {
				if ( event.target === paywallLoginModal ) {
					paywallLoginModal.style.display = 'none';
				}
			};

			paywallLoginButton.addEventListener( 'click', event => {
				event.preventDefault();
				const kickboxMessages = paywallLoginModal.querySelectorAll( '.kickbox-message' );

				if ( kickboxMessages ) {
					kickboxMessages.forEach( kickboxMessage => {
						kickboxMessage.remove();
					} );
				}

				const emailField = paywallLoginModal.querySelector( '#oakEmail' );
				const passwordField = paywallLoginModal.querySelector( '#oakPassword' );
				const nonceField = paywallLoginModal.querySelector( '#kelsey_oak_login' );

				const email = emailField.value;
				const password = passwordField.value;
				const nonce = nonceField.value;

				if ( ! email ) {
					removeErrorMessage();
					paywallLoginButton.insertAdjacentHTML( 'beforeBegin', getErrorMessage( 'Error', 'Email address is missing. Please insert your email address.' ) );
				}

				if ( ! password ) {
					removeErrorMessage();
					paywallLoginButton.insertAdjacentHTML( 'beforeBegin', getErrorMessage( 'Error', 'Password is missing. Please insert your password' ) );
				}

				if ( email && password ) {
					const emailVerify = emailValidation( email );

					if ( ! emailVerify ) {
						removeErrorMessage();
						paywallLoginButton.insertAdjacentHTML( 'beforeBegin', getErrorMessage( 'Error', 'The email you entered is not valid. Please try again.' ) );
					} else {
						oakGetSubscriptionStatus( paywallLoginButton, email, password, nonce );
					}
				}
			} );
		}
	}
}

// Check if email is a valid email format.
function emailValidation( enteredEmail ) {
	const emailFormat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

	if ( enteredEmail.match( emailFormat ) ) {
		return true;
	}
	return false;
}

// Check if email is registered as a subscriber on OAK, if yes then set cookies.
function oakGetSubscriptionStatus( form, email, password, nonce ) {
	const ajaxUrl = window.QalaPaywall.ajax_url;

	const registrationRequest = jQuery.post(ajaxUrl, {
		action: 'oak_get_subscriber_status',
		email,
		password,
		nonce,
	});
	const subscriptionRequest = jQuery.post(ajaxUrl, {
		action: 'oak_get_subscription_status',
		email,
		password,
		nonce,
	});

	form.classList.add('is-loading');

	jQuery.when(registrationRequest, subscriptionRequest).done((regResponse, subResponse) => {
		regResponse = regResponse[0];
		subResponse = subResponse[0];

		if ( ! regResponse.success || ! subResponse.success ) {
			removeErrorMessage();
			form.insertAdjacentHTML( 'beforeBegin', getErrorMessage( 'Error', 'Network error, please try again later or ' + getContactLink( 'contact our support.' ), false ) );

			form.classList.remove('is-loading');
		} else {
			try {
				const regBody = JSON.parse( regResponse.data.body );

				if ( ( regBody.result === 'Failure' && regBody.message !== 'Email address not found' ) || regBody.result === 'InvalidRequest' ) {
					removeErrorMessage();
					form.insertAdjacentHTML( 'beforeBegin', getErrorMessage( 'Error', 'Network error, please try again later or ' + getContactLink( 'contact our support.' ), false ) );

          form.classList.remove('is-loading');
					return;
				}

				if ( regBody.result === 'Failure' ) {
          form.insertAdjacentHTML( 'beforeBegin', getErrorMessage( 'Error', regBody.message, false ) );
          form.classList.remove('is-loading');
					return;
        }

				const subBody = JSON.parse( subResponse.data.body );

				if ( subBody.result === 'Failure' || subBody.result === 'InvalidResponse' ) {
					removeErrorMessage();
					let safeMessage = '';
					switch ( subBody.message ) {
						case 'Cannot find a customer with email address':
						case 'Password mismatch':
						case 'Customer not found':
						case 'Authentication Error':
							safeMessage = 'Email address or password is incorrect.';
							break;
						case 'No password':
							safeMessage = 'Password is missing. Please ' + getRegisterLink( 'click here' ) + ' to set your password.';
							break;
						default:
							safeMessage = escapeHTML( subBody.message );
					}
					form.insertAdjacentHTML( 'beforeBegin', getErrorMessage( 'Error', safeMessage, false ) );
          form.classList.remove('is-loading');
					return;
				}

				const customerData = setCustomerData( email, regBody.data );
				setRegistrationCookies( customerData );
				setGatingCookies( subBody.data );

				jQuery.post(ajaxUrl, {
					action: 'oak_send_access_report',
					postId: window.QalaPaywall.currentPostId,
					postTitle: window.QalaPaywall.currentPostTitle,
					typeForReportAccess: window.QalaPaywall.typeForReportAccess,
					nonce,
					customerData,
				}).done(() => {
					location.reload();
				}).fail(() => {
					location.reload();
				});
			} catch ( error ) {
				// eslint-disable-next-line
				console.error( error );
				removeErrorMessage();
				form.insertAdjacentHTML( 'beforeBegin', getErrorMessage( 'Error', 'An error occurred while processing your subscription. Please ' + getContactLink( 'contact our support.' ), false ) );
			}
		}
	});
}

// Set cookies with values from OAK subscription.
function setGatingCookies( customerData ) {
	if (!customerData) {
		return true;
	}

	const date = new Date();
	date.setTime( date.getTime() + ( 7 * 24 * 60 * 60 * 1000 ) );
	const cookieExpires = '; expires=' + date.toUTCString();

	const currentDate = formatDate( new Date() );

	const email = customerData.customer.email;

	const subscriptions = customerData.subscription;

	subscriptions.forEach( subscription => {
		const publication = subscription.publication;

		if ( publication === window.QalaPaywall.publicationCode ) {
			const subStatus = subscription.subStatus;
			const subType = subscription.subType;
			const continuous = subscription.continuous;
			const daysToExpiry = subscription.daysToExpiry;

			const encodeCookie = btoa( email + ',' + publication + ',' + subStatus + ',' + subType + ',' + continuous + ',' + daysToExpiry + currentDate );

			document.cookie = 'kelsey_data=' + encodeCookie + '; Path=/' + cookieExpires + ';';
		}
	} );
}

// Check that soft gating email form is loaded, if yes do dataValidation()
function initSoftGating() {
	const paywallForm = document.querySelector( '.paywall-form' );

	if ( paywallForm ) {
		const paywallEmailFields = paywallForm.querySelectorAll( 'input[type="email"]' );

		// Check for email fields.
		if ( paywallEmailFields.length ) {
			// Init kickbox validation for email fields.
			paywallEmailFields.forEach( field => {
				dataValidation( field, paywallForm );
			} );
		}
	}
}

// Data validation after submit, first on Kickbox if valid email, then check on OAK.
function dataValidation( field, form ) {
	const submitButton = form.querySelector( '.paywall-form-button input' );
	const termsConditionsCheck = form.querySelector( '.paywall-form-checkbox-terms' );

	submitButton.addEventListener( 'click', event => {
		event.preventDefault();
		if ( termsConditionsCheck && ! termsConditionsCheck.checked ) {
			removeErrorMessage();
			form.insertAdjacentHTML( 'beforeBegin', getErrorMessage( 'Error', 'Please agree to our terms and conditions.' ) );
			return;
		}
		kickboxValidate( field, form );
	} );

	field.addEventListener( 'keypress', event => {
		if ( event.keyCode === 13 ) {
			event.preventDefault();

			if ( termsConditionsCheck && ! termsConditionsCheck.checked ) {
				removeErrorMessage();
				form.insertAdjacentHTML( 'beforeBegin', getErrorMessage( 'Error', 'Please agree to our terms and conditions.' ) );
				return;
			}
			kickboxValidate( field, form );
		}
	} );
}

// Kickbox email verification
function kickboxValidate( field, form ) {
	const parent = field.parentElement;
	const email = field.value;
	const nonceField = form.querySelector( '#kelsey_soft_gating' );
	const nonce = nonceField.value;

	// Return if the email is the same as previous or the field is empty.
	if ( email === '' ) {
		removeErrorMessage();
		form.insertAdjacentHTML( 'beforeBegin', getErrorMessage( 'Error', 'Email address is missing. Please insert your email address.' ) );
		return;
	}

	const ajaxUrl = window.QalaPaywall.ajax_url;
	const data = {
		action: 'kickbox_validate_email',
		email,
		nonce,
	};

	// Set the loading spinner.
	parent.insertAdjacentHTML( 'beforeend', getLoadingSpinner() );

	jQuery.post( ajaxUrl, data, function( response ) {
		const { success } = response;
		const responseBody = JSON.parse( response.data );
		const { reason, result } = responseBody;

		// Toggle input field classes based on the result.
		field.closest( '.paywall-form-fields' ).classList.toggle( 'email-is-valid', result === 'deliverable' );
		field.closest( '.paywall-form-fields' ).classList.toggle( 'email-not-valid', result === 'undeliverable' );

		// Remove loading.
		form.querySelectorAll( '.kickbox-loading' ).forEach( loading => loading.remove() );

		// Remove all messages before setting a new one.
		form.querySelectorAll( '.kickbox-message' ).forEach( message => message.remove() );

		if ( ! success ) {
			removeErrorMessage();
			form.insertAdjacentHTML( 'beforeBegin', getErrorMessage( 'Error', 'Network error, try again later or ' + getContactLink( 'contact our support.' ), false ) );
		} else if ( result === 'undeliverable' || result === 'unknown' ) {
			removeErrorMessage();
			form.insertAdjacentHTML( 'beforeBegin', getErrorMessage( 'Error', errorMessages[ reason ] ) );
		} else {
			oakEmailVerificationCheck( form, email, nonce );
		}
	} );
}

// Check if email is registered on OAK.
function oakEmailVerificationCheck( form, email, nonce ) {
	const trialType = form.getAttribute( 'data-trial-status' );
	const trialCount = form.getAttribute( 'data-trial-count' );

	const ajaxUrl = window.QalaPaywall.ajax_url;
	const ajaxData = {
		action: 'oak_get_subscriber_status',
		email,
		nonce,
	};

	jQuery.post( ajaxUrl, ajaxData, function( response ) {
		const { success, data } = response;
		const responseBody = JSON.parse( data.body );

		if ( ! success ) {
			removeErrorMessage();
			form.insertAdjacentHTML( 'beforeBegin', getErrorMessage( 'Error', 'Network error, please try again later or ' + getContactLink( 'contact our support.' ), false ) );
			toggleSubmitButton( form, true );
		} else if ( ( responseBody.result === 'Failure' && responseBody.message !== 'Email address not found' ) || responseBody.result === 'InvalidRequest' ) {
			removeErrorMessage();
			form.insertAdjacentHTML( 'beforeBegin', getErrorMessage( 'Error', 'Network error, please try again later or ' + getContactLink( 'contact our support.' ), false ) );
			toggleSubmitButton( form, true );
		} else if ( responseBody.result === 'Failure' && responseBody.message === 'Email address not found' ) {
			oakRegisterCustomer( form, email, nonce, trialType, trialCount );
		} else {
			const customerData = setCustomerData( email, responseBody.data );
			setRegistrationCookies( customerData );
			setSoftGatingCookies( customerData.email, customerData.trialType, customerData.gatedLimit, customerData.gatedExpiryDate, customerData.gatedArticlesRead );
		}
	} );
}

// Register user on OAK.
function oakRegisterCustomer( form, email, nonce, trialType, trialCount ) {
	const currentPostId = window.QalaPaywall.currentPostId;
	const newsletterChecked = form.querySelector( '.paywall-form-checkbox-newsletter' );
	const gatedRegistration = 'Yes';

	const thirdPartyChecked = form.querySelector( '.paywall-form-checkbox-third-party' );

	let newsletterSignup = 'No';
	let newsletterSignupList = '';

	let thirdPartyHandling = 'No';

	if ( newsletterChecked && newsletterChecked.checked ) {
		const newsletterId = form.querySelector( '.paywall-form-checkbox-newsletter-id' );
		newsletterSignup = 'Yes';
		newsletterSignupList = newsletterId.getAttribute( 'data-newsletter-id' );
	}

	if ( thirdPartyChecked && thirdPartyChecked.checked ) {
		thirdPartyHandling = 'Yes';
	}

	const ajaxUrl = window.QalaPaywall.ajax_url;
	const ajaxData = {
		action: 'oak_register_customer',
		email,
		gatedRegistration,
		trialType,
		trialCount,
		currentPostId,
		newsletterSignup,
		newsletterSignupList,
		thirdPartyHandling,
		nonce,
	};

	jQuery.post( ajaxUrl, ajaxData, function( response ) {
		const { success, data } = response;
		const responseBody = JSON.parse( data.body );

		if ( ! success ) {
			removeErrorMessage();
			form.insertAdjacentHTML( 'beforeBegin', getErrorMessage( 'Error', 'Network error, please try again later or ' + getContactLink( 'contact our support.' ), false ) );
			toggleSubmitButton( form, true );
		} else if ( responseBody.result === 'Failure' || responseBody.result === 'InvalidResponse' ) {
			removeErrorMessage();
			form.insertAdjacentHTML( 'beforeBegin', getErrorMessage( 'Error', responseBody.message ) );
			toggleSubmitButton( form, true );
		} else {
			setSoftGatingCookies( email, trialType, trialCount );
		}
	} );
}

function setCustomerData( email, data ) {
	const registrationData = data?.registration || [];
	const publicationCode = window.QalaPaywall.publicationCode;

	let registered = '';
	let registeredDate = '';
	let gatedType = 'no_trial_mode';
	let gatedLimit = 'no_trial_mode';
	let gatedExpiryDate = '';
	let gatedArticlesRead = '';
	let trialType;
  let registrationID = '';

	if (registrationData.length) {
		registrationData.forEach( registration => {
			if ( registration.publication === publicationCode ) {
				if ( registration.registered ) {
					registered = registration.registered;
				}

				if ( registration.registeredDate ) {
					registeredDate = registration.registeredDate;
				}

				if ( registration.gatedType ) {
					gatedType = registration.gatedType;
				}

				if ( registration.gatedLimit ) {
					gatedLimit = registration.gatedLimit;
				}

				if ( registration.gatedExpiryDate ) {
					gatedExpiryDate = registration.gatedExpiryDate;
				}

				if ( registration.gatedArticlesRead ) {
					gatedArticlesRead = registration.gatedArticlesRead;
				}

        if ( registration.registrationID ) {
          registrationID = registration.registrationID;
        }
			}
		} );
	}

	if ( gatedType === 'articles' ) {
		trialType = 'by_articles_read';
	} else if ( gatedType === 'days' ) {
		trialType = 'by_days';
	} else {
		trialType = 'no_trial_mode';
	}

	return {
		'email': email,
		'registered': registered,
		'registeredDate': registeredDate,
		'trialType': trialType,
		'gatedLimit': gatedLimit,
		'gatedExpiryDate': gatedExpiryDate,
		'gatedArticlesRead': gatedArticlesRead,
    'registrationID': registrationID
	}
}

// Set cookies with values for soft gating.
function setSoftGatingCookies( email, trialType, trialCount, gatedExpiryDate = '', gatedArticlesRead = '' ) {
	const date = new Date();
	date.setTime( date.getTime() + ( 365 * 24 * 60 * 60 * 1000 ) );
	const cookieExpires = '; expires=' + date.toUTCString();

	const currentDate = formatDate( new Date() );

	if ( trialType === 'by_days' ) {
		let trialExpires = '';

		if ( gatedExpiryDate ) {
			trialExpires = gatedExpiryDate + ' 23:59:00';
			document.cookie = 'kelsey_soft_expires=' + trialExpires + '; Path=/' + cookieExpires + ';';
		} else {
			const expirationDate = new Date();
			expirationDate.setDate( expirationDate.getDate() + parseInt( trialCount ) );
			trialExpires = formatDate( expirationDate );
		}

		document.cookie = 'kelsey_soft_expires=' + trialExpires + '; Path=/' + cookieExpires + ';';
	}

	if ( trialType === 'by_articles_read' ) {
		if ( gatedArticlesRead ) {
			document.cookie = 'kelsey_soft_reads=' + gatedArticlesRead + '; Path=/' + cookieExpires + ';';
		} else {
			const currentPostId = window.QalaPaywall.currentPostId;
			document.cookie = 'kelsey_soft_reads=' + currentPostId + '; Path=/' + cookieExpires + ';';
		}
	}

	const encodeCookie = btoa( email + ',' + trialType + ',' + trialCount + ',' + currentDate );

	document.cookie = 'kelsey_soft_data=' + encodeCookie + '; Path=/' + cookieExpires + ';';

	// eslint-disable-next-line no-undef
	location.reload();
}

// Set cookies with values regarding registration.
function setRegistrationCookies( data ) {
	const date = new Date();
	date.setTime( date.getTime() + ( 365 * 24 * 60 * 60 * 1000 ) );
	const cookieExpires = '; expires=' + date.toUTCString();

	const currentDate = formatDate( new Date() );

	const encodeCookie = btoa( data.email + ',' + data.registered + ',' + data.registeredDate + ',' + currentDate );

	document.cookie = 'kelsey_registration_data=' + encodeCookie + '; Path=/' + cookieExpires + ';';
}

// Toggle submit button.
function toggleSubmitButton( form, state ) {
	form.querySelector( '.paywall-form-button input' ).disabled = state;
}

// Function to build a loading spinner.
function getLoadingSpinner() {
	return '<div class="kickbox-loading"><div></div></div>';
}

// Function to build the error message.
function getErrorMessage( type, message, escape = true ) {
	if ( escape ) {
		message = escapeHTML( message );
		type = escapeHTML( type );
	}

	return `<div class="kickbox-message kickbox-message__error">
		<p><strong>${ type }</strong>: ${ message }</p>
	</div>`;
}

// Function that generates contact our support link
function getContactLink( linkText ) {
	linkText = escapeHTML( linkText );
	if ( '' === QalaPaywall.support_url ) {
		return linkText;
	}

	return `<a href="${ QalaPaywall.support_url }">${ linkText }</a>`;
}

// Function that generates the link to register
function getRegisterLink( linkText ) {
	linkText = escapeHTML( linkText );
	if ( '' === QalaPaywall.register_url ) {
		return linkText;
	}

	return `<a href="${ QalaPaywall.register_url }" target="_blank">${ linkText }</a>`;
}

// Function to build the error message.
function getNoticeMessage( type, message, escape = true ) {
	if ( escape ) {
		message = escapeHTML( message );
		type = escapeHTML( type );
	}

	return `<div class="kickbox-message kickbox-message__notice">
		<p><strong>${ type }</strong>: ${ message }</p>
	</div>`;
}

// Function to remove all error messages.
function removeErrorMessage() {
	const errorDivs = document.querySelectorAll( '.kickbox-message' );

	if ( errorDivs ) {
		errorDivs.forEach( errorDiv => {
			errorDiv.remove();
		} );
	}
}

// Date formater.
function padTo2Digits( num ) {
	return num.toString().padStart( 2, '0' );
}

// Date formater.
function formatDate( date ) {
	return (
		[
			date.getFullYear(),
			padTo2Digits( date.getMonth() + 1 ),
			padTo2Digits( date.getDate() ),
		].join( '-' ) +
	' ' +
	[ padTo2Digits( date.getHours() ), padTo2Digits( date.getMinutes() ), padTo2Digits( date.getSeconds() ) ].join( ':' )
	);
}

// Redirect notice handler.
function initRedirectHandler() {
	const paywallWrapper = document.querySelector( '.paywall-wrapper' );
	const paywallLoginWrapper = document.querySelector( '.paywall-login' );

	if ( paywallWrapper ) {
		const subscribeButtonDiv = paywallWrapper.querySelector( '.paywall-buttons' );

		if ( subscribeButtonDiv ) {
			const subscribeButtons = subscribeButtonDiv.querySelectorAll( '.btn' );

			subscribeButtons.forEach( button => {
				button.addEventListener( 'click', () => {
					const redirectUrl = button.dataset.redirectUrl;
					if ( redirectUrl ) {
						redirectNotice( button, redirectUrl );
					}
				} );
			} );
		}
	}

	if ( paywallLoginWrapper ) {
		const loginButtons = paywallLoginWrapper.querySelectorAll( 'button' );

		if ( loginButtons ) {
			loginButtons.forEach( button => {
				button.addEventListener( 'click', () => {
					const redirectUrl = button.dataset.redirectUrl;
					if ( redirectUrl ) {
						redirectNotice( button, redirectUrl );
					}
				} );
			} );
		}
	}
}

// Add redirect notice when user clicks on button for redirection to Kelsey Shop.
function redirectNotice( button, redirectUrl ) {
	let count = 5;

	const counter = setInterval( () => {
		count = count - 1;

		if ( count <= 0 ) {
			clearInterval( counter );
			window.location.href = redirectUrl;
		}
		removeErrorMessage();
		button.parentElement.insertAdjacentHTML( 'afterend', getNoticeMessage( 'Notice', 'You will be redirected to our shop page in ' + count + ' seconds.' ) );
	}, 1000 );
}

/**
 * initDownloadButtons
 *
 * This function fires to register the on click handler for the download buttons
 */
function initDownloadButtons() {
	jQuery( 'button[data-download-link]' ).click( event => {
		triggerDownload( event.target );
	} );
}

/**
 * triggerDownload
 *
 * This function is the handler that opens the download link in a new tab.
 *
 * @param {Object} button
 */
function triggerDownload( button ) {
	const downloadLink = button.dataset.downloadLink;
	const downloadName = button.dataset.downloadName;

	window.open( downloadLink, '_blank' );

	gtag(
		'event',
		'downloadBtnClick',
		{
			downloadLink,
			downloadName,
			publication: window.QalaPaywall.publication,
			postId: window.QalaPaywall.currentPostId,
		}
	);
}

function showURLMessage() {
	const container = document.querySelector( '.paywall-wrapper' );

	if (container) {
    const buttons = container.querySelector( '.paywall-buttons' );

		const urlParams = new URLSearchParams( window.location.search );
		const message = escapeHTML( decodeURI( urlParams.get( 'message' ) ) );
		if ( message && message !== 'null' ) {
			buttons.insertAdjacentHTML( 'afterend', getNoticeMessage( 'Notice', message ) );
		}
	}
}

function moveLoginHtml() {
	const container = document.getElementById('td-outer-wrap');
	if ( container ) {
		const paywallLogin = Array.from(document.querySelectorAll( '.paywall-login' ));

		if ( paywallLogin.length ) {
			paywallLogin.forEach((login) => {
				container.appendChild(login);
			});
		}
	}
}
